import React from "react";
import { Link } from "react-router-dom";
import teamMembers from "../../OurTeam/teamMembersDetails.js";



/* ✅ UPDATED CARD WITH FRONT + BACK + READ MORE */
const TeamMemberCard = ({ name, title, company, img, bio, slug }) => (
  <div className="our-team-flip-card">
    <div className="our-team-flip-inner">

      {/* FRONT */}
      <div className="our-team-flip-front our-team-card">
        <div className="our-team-img-wrapper">
          <img
            src={img}
            alt={`Portrait of ${name}`}
            className="our-team-img"
            loading="lazy"
          />
        </div>
        <h4 className="our-team-name">{name}</h4>
        <p className="our-team-role">{title}</p>
        <p className="our-team-company">{company}</p>
      </div>

      {/* BACK */}
      <div className="our-team-flip-back">
        <h4 className="our-team-name">{name}</h4>

        <p className="our-team-bio">
          {bio}
        </p>

        {slug && (
          <Link
            to={`/member/${slug}`}
            className="our-team-readmore"
            aria-label={`Read more about ${name}`}
          >
            Read More →
          </Link>
        )}
      </div>

    </div>
  </div>
);



/* ✅ MAIN SECTION */
export default function OurTeamSection() {
  return (
    <section className="our-team-section">
      <div className="our-team-container">

        <header className="our-team-header">
          <h2 className="our-team-title text-light">
            Our National Council Members
          </h2>
        </header>

        <div className="our-team-grid">
          {teamMembers.map((member) => (
            <TeamMemberCard key={member.slug} {...member} />
          ))}
        </div>

        <a
          href="/national-member"
          className="our-team-btn"
          aria-label="View the full list of national members"
        >
          View All
        </a>

      </div>
    </section>
  );
}
